<template>
  <v-wait for='loading unit' class='layout column fill-height'>
    <template slot='waiting'>
      <v-container>
        <v-flex md6>
          <vcl-list height='200'></vcl-list>
        </v-flex>
      </v-container>
    </template>
    <container-toolbar v-if='unit && isContainerUnit' :unit='unit'></container-toolbar>
    <vehicle-toolbar v-if='unit && isVehicleUnit' :unit='unit'></vehicle-toolbar>
    <v-container fluid grid-list-md v-if='unit'>
      <v-layout row wrap>
        <v-flex md6>
          <v-layout column class='px-1 view-cols'>
            <scheduled-services-list :unit='unit' class='mb-3'></scheduled-services-list>
            <unit-date-based-tasks :unit='unit' class='mb-3'></unit-date-based-tasks>
            <scheduled-defects-list :unit='unit' class='mb-3'></scheduled-defects-list>
            <completed-defects-list :unit='unit' class='mb-3'></completed-defects-list>
          </v-layout>
        </v-flex>
        <v-flex md6>
          <v-layout column class='px-1'>
            <unit-details :unit='unit' class='mb-3'></unit-details>
            <unit-warranties v-if='isVehicleUnit' :unit='unit' class='mb-3'></unit-warranties>
            <custom-warranty-list v-if='isVehicleUnit' :unit='unit' class='mb-3'></custom-warranty-list>
            <unit-meter-resets v-if='isVehicleUnit' :unit='unit' class='mb-3'></unit-meter-resets>
            <unit-nhvas-history v-if='isVehicleUnit' :unit='unit' class='mb-3'></unit-nhvas-history>
            <unit-vehicle-off-road v-if='isVehicleUnit' :unit='unit' class='mb-3'></unit-vehicle-off-road>
            <unit-configurations :unit='unit' @input='updateUnit' class='mb-3'></unit-configurations>
            <brake-check-configuration :unit='unit' class='mb-3' v-if='showBrakeChecks && isVehicleUnit'></brake-check-configuration>
            <completed-services-list :unit='unit'></completed-services-list>
            <completed-date-based-task-list class='mb-3'></completed-date-based-task-list>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-wait>
</template>

<script>
import CONFIG from '@/config';
import { VclList } from 'vue-content-loading';
import Unit from './UnitsClient.vue';
import GarageLocations from '@/components/GarageLocations/GarageLocationsClient.vue';
import UnitConfigurations from './Details/UnitConfigurations.vue';
import UnitDateBasedTasks from './Details/UnitDateBasedTasks.vue';
import UnitDetails from './Details/UnitDetails.vue';
import UnitWarranties from './Details/UnitWarranties.vue';
import UnitMeterResets from './Details/UnitMeterResets.vue';
import CompletedDateBasedTaskList from './CompletedDateBasedTaskList.vue';
import CompletedServicesList from './Details/Services/CompletedServicesList.vue';
import ScheduledServicesList from './Details/Services/ScheduledServicesList.vue';
import ScheduledDefectsList from './Details/Defects/ScheduledDefectsList.vue';
import CompletedDefectsList from './Details/Defects/CompletedDefectsList.vue';
import DateBasedTask from '@/components/DateBasedTasks/DateBasedTasksClient';
import UnitVehicleOffRoad from './Details/VehicleOffRoad/VehicleOffRoadList.vue';
import VehicleOffRoad from './VehicleOffRoadClient.vue';
import BrakeCheckConfiguration from './Details/BrakeCheck/BrakeCheckConfiguration.vue';
import UserClient from '@/components/Users/UsersClient.vue';
import ServicesClient from '@/components/Services/ServicesClient';
import { Event } from '@/plugins/bus';
import { UnitType } from '@/models/enums';
import ContainerToolbar from '@/components/Units/ContainerToolbar';
import VehicleToolbar from '@/components/Units/VehicleToolbar';
import UnitNhvasHistory from '@/components/Units/Details/UnitNhvasHistory';
import CustomWarrantyList from './Details/CustomWarranty/CustomWarrantyList.vue';

export default {
  mixins: [UserClient, Unit, DateBasedTask, GarageLocations, ServicesClient],
  components: {
    UnitNhvasHistory,
    VehicleToolbar,
    ContainerToolbar,
    VclList,
    UnitConfigurations,
    UnitDateBasedTasks,
    UnitDetails,
    UnitWarranties,
    UnitMeterResets,
    CompletedServicesList,
    CompletedDateBasedTaskList,
    ScheduledServicesList,
    ScheduledDefectsList,
    CompletedDefectsList,
    VehicleOffRoad,
    UnitVehicleOffRoad,
    BrakeCheckConfiguration,
    CustomWarrantyList
  },
  data() {
    return {
      unit: null,
      showBrakeChecks: CONFIG.featureToggles.brakeCheckEnabled
    };
  },
  computed: {
    unitId() {
      return this.$route.params.unitId;
    },
    isVehicleUnit() {
      return this.unit.unitType === UnitType.Vehicle;
    },
    isContainerUnit() {
      return this.unit.unitType === UnitType.Container;
    }
  },
  methods: {
    async handleMeterResetAddPending(data) {
      await this.addMeterReset(data.unitId, data.id, data);
    },
    async handleMeterResetUpdatePending(data) {
      await this.updateMeterReset(data.unitId, data);
    },
    async handleMeterResetDeletePending(data) {
      await this.deleteMeterReset(data.unitId, data.id);
    },
    async handleVehicleOffRoadDeletePending(data) {
      await this.deleteVehicleOffRoad(data.unitId, data.id);
    },
    async handleCompletedServiceDeletePending(data) {
      await this.deleteCompletedService(data.id);
    },
    async handleVehicleOffRoadUpdatePending(data) {
      await this.updateVehicleOffRoad(data.unitId, data);
    },
    async handleMeterResetDeleted() {
      this.unit = await this.getUnit(this.unitId);
    },
    async handleMeterResetUpdated() {
      this.unit = await this.getUnit(this.unitId);
    },
    async handleBrakeCheckUpdated() {
      //nothing to do?
    },
    async handleDateBasedTaskDeletePending(data) {
      await this.deleteDateBasedTask(data.id);
    }
  },
  async mounted() {
    await this.loadUserGarages();

    this.unit = await this.getUnit(this.unitId);

    this.$bus.$on(Event.UnitMeterResetPendingAdd, this.handleMeterResetAddPending);
    this.$bus.$on(Event.UnitMeterResetPendingUpdate, this.handleMeterResetUpdatePending);
    this.$bus.$on(Event.UnitMeterResetPendingDelete, this.handleMeterResetDeletePending);
    this.$bus.$on(Event.VehicleOffRoadPendingUpdate, this.handleVehicleOffRoadUpdatePending);
    this.$bus.$on(Event.VehicleOffRoadPendingDelete, this.handleVehicleOffRoadDeletePending);
    this.$bus.$on(Event.UnitMeterResetUpdated, this.handleMeterResetUpdated);
    this.$bus.$on(Event.UnitMeterResetDeleted, this.handleMeterResetDeleted);
    this.$bus.$on(Event.DateBasedTaskPendingDelete, this.handleDateBasedTaskDeletePending);
    this.$bus.$on(Event.DateBasedTaskDeleted, this.handleDateBasedTaskDeleted);
    this.$bus.$on(Event.BrakeCheckUpdated, this.handleBrakeCheckUpdated);
    this.$bus.$on(Event.ServicePendingDelete, this.handleCompletedServiceDeletePending);
  },
  watch: {
    async unitId() {
      this.unit = await this.getUnit(this.unitId);
    }
  },
  destroyed() {
    this.$bus.$off(Event.UnitMeterResetPendingAdd, this.handleMeterResetAddPending);
    this.$bus.$off(Event.UnitMeterResetPendingUpdate, this.handleMeterResetUpdatePending);
    this.$bus.$off(Event.UnitMeterResetPendingDelete, this.handleMeterResetDeletePending);
    this.$bus.$off(Event.VehicleOffRoadPendingUpdate, this.handleVehicleOffRoadUpdatePending);
    this.$bus.$off(Event.VehicleOffRoadPendingDelete, this.handleVehicleOffRoadDeletePending);
    this.$bus.$off(Event.UnitMeterResetUpdated, this.handleMeterResetUpdated);
    this.$bus.$off(Event.UnitMeterResetDeleted, this.handleMeterResetDeleted);
    this.$bus.$off(Event.DateBasedTaskPendingDelete, this.handleDateBasedTaskDeletePending);
    this.$bus.$off(Event.DateBasedTaskDeleted, this.handleDateBasedTaskDeleted);
    this.$bus.$off(Event.BrakeCheckUpdated, this.handleBrakeCheckUpdated);
    this.$bus.$off(Event.ServicePendingDelete, this.handleCompletedServiceDeletePending);
  }
};
</script>
<style lang='scss'>
.unit-header-left-col {
  display: inline-block;
  width: 200px;
}
</style>
